import React from 'react';
import '../../../../css/role-style.css';
import { Card, Checkbox, Form, Input, Select } from 'antd';
import { StaffRole } from '../../../../generated';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
interface RoleDetailProps {
  roleSubtype: string;
  data: StaffRole;
  canEditRole: boolean;
}

export const RoleDetail: React.FC<RoleDetailProps> = (props) => {
  const dropDownValue = [
    {
      label: 'IS',
      value: 'Staff.IS'
    },
    {
      label: 'Case Worker',
      value: 'Staff.CaseWorker'
    },
    {
      label: 'Finance',
      value: 'Staff.Finance'
    },
    {
      label: 'ReadOnly',
      value: 'Staff.ReadOnly'
    }
  ];

  const [form] = Form.useForm();
  const navigate = useNavigate();


  return (
    <><>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: '10px',
          marginTop: '-65px',
          marginRight: '10px',
        }}
      >
        <Button
          type="primary"
          disabled={!props.canEditRole}
          onClick={() => {
            const newPath = location.pathname.replace('detail', 'edit');
            navigate(newPath);
          } }
        >
          Edit Role
        </Button>
      </div>
    </><div className="container">
        <div className="pageHeading">
          <div className="rightSide">
            <div className="actionMenu"></div>
          </div>
        </div>
        <Form
          initialValues={props.data}
          form={form}
          layout="vertical"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'right',
            justifyContent: 'end'
          }}
        >
          <Card style={{ marginBottom: '10px', padding: '20px 50px' }}>
            <div className="roleContainer">
              <div className="sectionName">
                <h3>Role Info</h3>
                <div className="roleInputs">
                  <div className="formBox">
                    <Form.Item label="Role Name" style={{ width: '100%' }} rules={[{ required: true, message: 'Entity Name is Required' }]} name={'roleName'}>
                      <Input disabled={true} />
                    </Form.Item>
                  </div>
                  {props.roleSubtype === 'Staff.IS' ? (
                    <div className="formBox">
                      <Form.Item
                        label="Role Sub Type"
                        style={{ width: '100%' }}
                        rules={[
                          {
                            required: true,
                            message: 'Role Sub type is Required'
                          }
                        ]}
                        name={'roleSubtype'}
                      >
                        <Select disabled={true}>
                          {dropDownValue?.map((subRole) => (
                            <Option value={subRole.value} key={subRole?.value}>
                              {subRole.label}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="rolePermission">
                  <div className="sectionName">
                    <h3>Permissions</h3>
                  </div>
                  <div className="roleInputs">
                    {/* ID Case */}
                    <div className="permissionSubSection">
                      <div className="header">
                        <p>ID Case</p>
                      </div>
                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canSearchCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel"> Can Search Cases</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canViewUnassignedCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Unassigned Cases</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item
                            name={['permissions', 'idCasePermissions', 'canViewCasesAssignedToOthers']}
                            valuePropName="checked"
                            style={{ margin: '0px', padding: '0px' }}
                          >
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Cases Assigned to Others</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canBeAssignedCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Be Assigned Case</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox deep">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canAssignSelf']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Assign Self</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox deep">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canUnassignSelf']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Unassign Self</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canAssignCaseWorker']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Assign Case Worker</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canUnassignCaseWorker']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Unassign Case Worker</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>

                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canIssueRefunds']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Issue Refund</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canViewCaseHistory']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Case History</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'idCasePermissions', 'canReopenCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Reopen Case</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    {/* Verification Case */}
                    <div className="permissionSubSection">
                      <div className="header">
                        <p>Verification Case</p>
                      </div>
                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canSearchCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel"> Can Search Cases</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canViewUnassignedCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Unassigned Cases</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item
                            name={['permissions', 'credCasePermissions', 'canViewCasesAssignedToOthers']}
                            valuePropName="checked"
                            style={{ margin: '0px', padding: '0px' }}
                          >
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Cases Assigned to Others</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canBeAssignedCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Be Assigned Cases</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox deep">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canAssignSelf']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Assign Self</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox deep">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canUnassignSelf']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Unassign Self</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canAssignCaseWorker']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Assign Case Worker</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canUnassignCaseWorker']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Unassign Case Worker</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>

                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canIssueRefunds']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Issue Refund</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canViewCaseHistory']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Case History</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'credCasePermissions', 'canReopenCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Reopen Case</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    {/* Send Case */}
                    <div className="permissionSubSection">
                      <div className="header">
                        <p>Send Case</p>
                      </div>
                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canSearchCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel"> Can Search Cases</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canViewUnassignedCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Unassigned Cases</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item
                            name={['permissions', 'sendCasePermissions', 'canViewCasesAssignedToOthers']}
                            valuePropName="checked"
                            style={{ margin: '0px', padding: '0px' }}
                          >
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Cases Assigned to Others</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canBeAssignedCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Be Assigned Cases</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox deep">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canAssignSelf']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Assign Self</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox deep">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canUnassignSelf']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Unassign Self</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canAssignCaseWorker']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              {' '}
                              <p className="checkBoxLabel">Can Assign Case Worker</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canUnassignCaseWorker']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Unassign Case Worker</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>

                      <div className="permissionSubSectionInput">
                        <div className="formBox">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canIssueRefunds']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Issue Refund</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canViewCaseHistory']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can View Case History</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <div className="formBox">
                          <Form.Item name={['permissions', 'sendCasePermissions', 'canReopenCases']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                            <Checkbox disabled={true}>
                              <p className="checkBoxLabel">Can Reopen Case</p>
                            </Checkbox>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <Card style={{ marginBottom: '10px', padding: '20px 50px' }}>
            <div className="roleContainer">
              <div className="rolePermission">
                <div className="roleInputs">
                  {/* Role */}
                  <div className="permissionSubSection">
                    <div className="header">
                      <p>Role</p>
                    </div>
                    <div className="permissionSubSectionInput">
                      <div className="formBox">
                        <Form.Item name={['permissions', 'rolePermissions', 'canSearchRoles']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel">Can Search Roles</p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item name={['permissions', 'rolePermissions', 'canAddRoles']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel"> Can Add Roles </p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item name={['permissions', 'rolePermissions', 'canEditRoles']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel"> Can Edit Roles </p>
                          </Checkbox>
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  {/* Staff */}
                  <div className="permissionSubSection">
                    <div className="header">
                      <p>Staff</p>
                    </div>
                    <div className="permissionSubSectionInput">
                      <div className="formBox">
                        <Form.Item name={['permissions', 'staffUserPermissions', 'canSearchStaff']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel">Can Search Staff</p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item name={['permissions', 'staffUserPermissions', 'canAssignRoles']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel">Can Assign Roles </p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item name={['permissions', 'staffUserPermissions', 'canBlockAccess']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel">Can Block Access</p>
                          </Checkbox>
                        </Form.Item>
                      </div>
                      <div className="formBox">
                        <Form.Item name={['permissions', 'staffUserPermissions', 'canAddOrRemoveTags']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel">Can Add/Remove Tags</p>
                          </Checkbox>
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  {/* Applicants */}
                  <div className="permissionSubSection">
                    <div className="header">
                      <p>Applicants</p>
                    </div>
                    <div className="permissionSubSectionInput">
                      <div className="formBox">
                        <Form.Item name={['permissions', 'applicantUserPermissions', 'canSearchApplicants']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            <p className="checkBoxLabel">Can Search Applicants</p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item
                          name={['permissions', 'applicantUserPermissions', 'canUpdatePersonalInformation']}
                          valuePropName="checked"
                          style={{ margin: '0px', padding: '0px' }}
                        >
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel">Can Update Personal Information</p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item name={['permissions', 'applicantUserPermissions', 'canBlockAccess']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel">Can Block Access</p>
                          </Checkbox>
                        </Form.Item>
                      </div>
                      <div className="formBox">
                        <Form.Item name={['permissions', 'applicantUserPermissions', 'canAddOrRemoveTags']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            {' '}
                            <p className="checkBoxLabel">Can Add/Remove Tags</p>
                          </Checkbox>
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  {/* Entity */}
                  <div className="permissionSubSection">
                    <div className="header">
                      <p>Entity</p>
                    </div>
                    <div className="permissionSubSectionInput">
                      <div className="formBox">
                        <Form.Item name={['permissions', 'entityPermissions', 'canSearchEntities']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            <p className="checkBoxLabel">Can Search Entities</p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item name={['permissions', 'entityPermissions', 'canAddEntities']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            <p className="checkBoxLabel"> Can Add Entities </p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item name={['permissions', 'entityPermissions', 'canEditEntities']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            <p className="checkBoxLabel"> Can Edit Entities </p>
                          </Checkbox>
                        </Form.Item>
                      </div>

                      <div className="formBox">
                        <Form.Item name={['permissions', 'entityPermissions', 'canDeleteEntities']} valuePropName="checked" style={{ margin: '0px', padding: '0px' }}>
                          <Checkbox disabled={true}>
                            <p className="checkBoxLabel"> Can Delete Entities </p>
                          </Checkbox>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Form>
      </div></>
  );
};
